import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import Tooltip from 'antd/es/tooltip';
import cn from 'classnames';
import type { ComponentProps, ReactNode } from 'react';

type TooltipIconWrapperProps = {
  tooltipTitle: string;
  children: ReactNode;
  placement?: ComponentProps<typeof Tooltip>['placement'];
} & ComponentProps<typeof QuestionMarkCircleIcon>;

export const TooltipIconWrapper = ({
  tooltipTitle,
  className,
  children,
  placement,
  ...props
}: TooltipIconWrapperProps) => {
  return (
    <Tooltip title={tooltipTitle} placement={placement}>
      <div className="flex items-center gap-1">
        {children}
        <QuestionMarkCircleIcon
          {...props}
          className={cn('size-4', className)}
        />
      </div>
    </Tooltip>
  );
};
